import N8nCard from './Card.vue';

export default N8nCard;
